import { env } from "../../../lib/env.ts";
import { logger } from "../../../lib/logger.ts";
import { ok, err, type Result, type ClientErrorCode } from "../../../lib/errors.ts";
import type { SubmitLeadPayload } from "../../../lib/schemas/index.ts";

/**
 * POST the lead to the submit-lead Edge Function. The function holds the Turnstile
 * secret + rate-limit and is the only write path; RLS is the final guard. Returns a
 * typed Result — never throws across this seam.
 */
export async function submitLead(payload: SubmitLeadPayload): Promise<Result<void>> {
  try {
    const res = await fetch(env.submitLeadUrl, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        // The Supabase gateway still requires the anon apikey to route, even though
        // the function itself is verify_jwt=false.
        apikey: env.supabaseAnonKey,
        authorization: `Bearer ${env.supabaseAnonKey}`,
      },
      body: JSON.stringify(payload),
    });

    let body: { ok?: boolean; code?: string } = {};
    try {
      body = (await res.json()) as { ok?: boolean; code?: string };
    } catch {
      // non-JSON / empty body — fall through to generic handling
    }

    if (res.ok && body.ok === true) return ok(undefined);

    const code = (body.code ?? "unknown") as ClientErrorCode;
    logger.warn("submit_lead_rejected", { status: res.status, code });
    return err(code);
  } catch (e) {
    logger.error("submit_lead_network", { message: e instanceof Error ? e.message : "unknown" });
    return err("network");
  }
}
